import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import { Form, Input, Button, Alert , Col, Row, notification } from "antd";

export const Contact = ()=>{

  const utilisateurs = JSON.parse(sessionStorage.getItem("utilisateurs"))?.user.profil
 
  const [loading, setloading] = useState(false)
  const [form] = Form.useForm();

  const [apis, contextHolder] = notification.useNotification();

  const [api2, contextHolder2] = notification.useNotification();

  const openNotificationWithIcon = () => {
    apis['success']({
      message: '',
      description:
        "Le message a été envoyer avec succès",
    });
  };

  const openNotificationWithIcon1 = () => {
    api2['error']({
      message: '',
      description:
        "Le message n'a pas été envoyer",
    });
  };

  const onFinish = (values) => {
    setloading(true)
    console.log(values)
    handleSubmit({...values});
  };


  const handleSubmit = (data) => {
   

    emailjs
      .send('service_dvldjbn', 'template_p1hcdxw', data, 'tQApkB8pywKcJcYtZ')
      .then((response) => {
        console.log('E-mail sent successfully:', response);
        openNotificationWithIcon();
        setloading(false)
        form.resetFields();
      })
      .catch((error) => {
        openNotificationWithIcon1();
        console.error('Error sending e-mail:', error);
      });
  };

    return(
        <>
              {contextHolder} {contextHolder2}
  <div id="contact" className="contact-us section">
    <div className="container">
      <div className="row">
        <div className="col-lg-5 align-self-center wow fadeInLeft" data-wow-duration="0.5s" data-wow-delay="0.25s">
          <div className="section-heading">
            <h2>Avez vous des questions ?</h2>
            <p>N'hésitez pas à nous envoyer un message, nous somme là pour vous répondre !</p>
            <div className="phone-info">
              <h4>Pour toute demande, appelez-nous : <span><i className="fa fa-phone"></i> <a href="#">+242069535084</a></span>
              </h4>
            </div>
          </div>
        </div>
        <div className="col-lg-7 wow fadeInRight" data-wow-duration="0.5s" data-wow-delay="0.25s">
          <Form form={form} onFinish={onFinish} layout="vertical" id='contact' 
          initialValues={
            utilisateurs?{
              nom:  utilisateurs.last_name,
              email: utilisateurs.email
            }:undefined
          }
          >
          <Row gutter={16}>
          <Col span={12} >
          <Form.Item
        name="nom"
        label="Nom"
        rules={[
            { required: true, message: 'Veuillez entrer votre nom !' },
        ]}
      >
        <Input
          placeholder="Entrer votre Nom"
        />
      </Form.Item>
          </Col>

          <Col span={12}>
          <Form.Item
        name="email"
        label="Email"
        rules={[
            { required: true, message: 'Veuillez entrer votre email !' },
            { type: 'email', message: 'Adresse email invalide !' }
        ]}
      >
        <Input
          placeholder="Entrer votre Email"
          
         
        />
      </Form.Item>
          </Col>

          

          <Col span={24} >
          <Form.Item
        name="message"
        label="Message"
        rules={[
            { required: true, message: 'Veuillez entrer votre message !' },
            
        ]}
      >
       <Input.TextArea  placeholder="Entrer votre message" />
      </Form.Item>
          </Col>
       
          </Row>
        <div className='text-center'>
        <Button type="primary" style={{paddingBottom: "35px"}} loading={loading}  htmlType="submit">
              Envoyer le message
        </Button>
        </div>
          
          </Form>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}